import { render, staticRenderFns } from "./oilCardManagement.vue?vue&type=template&id=153e107f&scoped=true"
import script from "./oilCardManagement.vue?vue&type=script&lang=js"
export * from "./oilCardManagement.vue?vue&type=script&lang=js"
import style0 from "./oilCardManagement.vue?vue&type=style&index=0&id=153e107f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e107f",
  null
  
)

export default component.exports